import { normalizeHigieneOralSimplificada } from '../data/higieneOralSimplificada';
import { CPO_CEO_FILAS } from '../data/indicesCpoCeo';
import { diagnosticosConDatos } from '../data/planDiagnosticoMsp';
import { tratamientosConDatos } from '../data/planTratamientoMsp';

function hasVal(v) {
  return v !== undefined && v !== null && String(v).trim() !== '';
}

export function hosTieneDatos(form) {
  const hos = form?.higieneOralSimplificada || normalizeHigieneOralSimplificada(form || {});
  const filas = hos?.filas || [];
  return filas.some(
    (f) =>
      hasVal(f.placa) ||
      hasVal(f.calculo) ||
      hasVal(f.gingivitis) ||
      (f.marcas || []).some(Boolean)
  );
}

export function indicadoresColsTieneDatos(form) {
  return (
    hasVal(form?.enfermedadPeriodontal) ||
    hasVal(form?.angleClasificacion) ||
    hasVal(form?.fluorosis) ||
    hasVal(form?.maloclusion)
  );
}

export function cpoCeoTieneDatos(form) {
  if (!form) return false;
  return CPO_CEO_FILAS.some((fila) => fila.cols.some((c) => hasVal(form[c.key])));
}

export function mspIndicadoresTieneDatos(form) {
  return (
    hosTieneDatos(form) ||
    indicadoresColsTieneDatos(form) ||
    cpoCeoTieneDatos(form) ||
    hasVal(form?.placa) ||
    hasVal(form?.calculo) ||
    hasVal(form?.gingivitis)
  );
}

export function mspRegistroCompletoResumen(form) {
  return {
    indicadores: mspIndicadoresTieneDatos(form),
    diagnosticos: diagnosticosConDatos(form?.tablaDiagnosticosMSP).length,
    tratamientos: tratamientosConDatos(form?.tablaTratamientosMSP).length,
    profesional:
      hasVal(form?.profesionalNombreApellidos) ||
      hasVal(form?.profesionalRegistroMSP) ||
      hasVal(form?.profesionalFirmaElectronicaNotas),
  };
}
